/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { classificationsControllerFindAll } from "./classificationsControllerFindAll";
import { classificationsControllerFindOne } from "./classificationsControllerFindOne";

export function documentClassificationsService() {
  return { classificationsControllerFindAll, classificationsControllerFindOne }
}